// apps/web/src/components/dashboard/PrefsFilterChip.tsx
//
// "Showing for: 5 sectors, 3 countries — clear filters to see all" chip
// per spec §3.5. Renders only when at least one pref is active.
// Clicking "clear filters" temporarily switches the page to global view
// (does NOT modify saved prefs — that's a Settings concern).

import { Button } from '@/components/ui/button'
import { X } from 'lucide-react'

export interface PrefsFilterChipProps {
  sectorCount: number
  countryCount: number
  vendorCount?: number
  onClear: () => void
}

function pluralise(n: number, singular: string, plural: string): string {
  return `${n} ${n === 1 ? singular : plural}`
}

export function PrefsFilterChip(props: PrefsFilterChipProps) {
  const parts: string[] = []
  if (props.sectorCount > 0)
    parts.push(pluralise(props.sectorCount, 'sector', 'sectors'))
  if (props.countryCount > 0)
    parts.push(pluralise(props.countryCount, 'country', 'countries'))
  if (props.vendorCount && props.vendorCount > 0) {
    parts.push(pluralise(props.vendorCount, 'vendor', 'vendors'))
  }
  if (parts.length === 0) return null

  return (
    <div
      className="flex items-center gap-2 rounded-md border border-border bg-muted px-3 py-2 text-sm"
      role="status"
    >
      <span className="text-muted-foreground">
        Showing for:{' '}
        <span className="font-medium text-foreground">
          {parts.join(', ')}
        </span>
      </span>
      <Button
        size="sm"
        variant="ghost"
        onClick={props.onClear}
        aria-label="Clear filters"
      >
        <X className="mr-1 h-3 w-3" /> clear filters
      </Button>
    </div>
  )
}
